webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(11);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(7);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PasswordStrengthMeter = __webpack_require__(8);
	
	var _PasswordStrengthMeter2 = _interopRequireDefault(_PasswordStrengthMeter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    Password: _PasswordStrengthMeter2.default
	  }
	};

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _zxcvbn = __webpack_require__(14);
	
	var _zxcvbn2 = _interopRequireDefault(_zxcvbn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    id: {
	      type: String,
	      default: 'password'
	    },
	    placeholder: {
	      type: String,
	      default: 'Please enter your password'
	    },
	    name: {
	      type: String,
	      default: 'password'
	    },
	    required: {
	      type: Boolean,
	      default: true
	    },
	    secureLength: {
	      type: Number,
	      default: 7
	    },
	    badge: {
	      type: Boolean,
	      default: true
	    },
	    defaultClass: {
	      type: String,
	      default: 'Password__field'
	    },
	    errorClass: {
	      type: String,
	      default: 'has-error'
	    },
	    successClass: {
	      type: String,
	      default: 'is-success'
	    },
	    strengthMeterClass: {
	      type: String,
	      default: 'Password__strength-meter'
	    },
	    strengthMeterFillClass: {
	      type: String,
	      default: 'Password__strength-meter--fill'
	    }
	  },
	  data: function data() {
	    return {
	      password: null
	    };
	  },
	
	
	  computed: {
	    passwordStrength: function passwordStrength() {
	      return this.password ? (0, _zxcvbn2.default)(this.password).score : null;
	    },
	    isSecure: function isSecure() {
	      return this.password ? this.password.length >= this.secureLength : null;
	    },
	    isActive: function isActive() {
	      return this.password && this.password.length > 0;
	    },
	    passwordCount: function passwordCount() {
	      return this.password && (this.password.length > this.secureLength ? this.secureLength + '+' : this.password.length);
	    }
	  }
	};

/***/ },
/* 5 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 6 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(6)
	
	/* script */
	__vue_exports__ = __webpack_require__(3)
	
	/* template */
	var __vue_template__ = __webpack_require__(10)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(5)
	
	/* script */
	__vue_exports__ = __webpack_require__(4)
	
	/* template */
	var __vue_template__ = __webpack_require__(9)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 9 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "Password"
	  }, [_c('div', {
	    staticClass: "Password__group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.password),
	      expression: "password"
	    }],
	    class: [_vm.defaultClass],
	    attrs: {
	      "type": "password",
	      "name": _vm.name,
	      "id": _vm.id,
	      "placeholder": _vm.placeholder,
	      "required": _vm.required
	    },
	    domProps: {
	      "value": _vm._s(_vm.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.password = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.badge) ? _c('div', {
	    staticClass: "Password__badge",
	    class: [_vm.isSecure ? _vm.successClass : '', !_vm.isSecure && _vm.isActive ? _vm.errorClass : '']
	  }, [_vm._v("\n      " + _vm._s(_vm.passwordCount) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    class: [_vm.strengthMeterClass]
	  }, [_c('div', {
	    class: [_vm.strengthMeterFillClass],
	    attrs: {
	      "data-score": _vm.passwordStrength
	    }
	  })])])
	},staticRenderFns: []}

/***/ },
/* 10 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('h1', [_vm._v("Password Strength Meter")]), _vm._v(" "), _c('password')], 1)
	},staticRenderFns: []}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.9088f8c5abfe638e16d0.js